import { BAYS, Roles } from '../../../../constants';

import type { PlanBayOption } from './types';

export const TREATMENT_PLAN_V3_STATUS = {
  COMPLETED: 'COMPLETED',
  STARTED: 'STARTED',
  EDITING: 'EDITING',
  READ_ONLY: 'READ_ONLY',
} as const;

export const TP_CONCLUDED_STATUSES = [
  TREATMENT_PLAN_V3_STATUS.COMPLETED,
  TREATMENT_PLAN_V3_STATUS.EDITING,
  TREATMENT_PLAN_V3_STATUS.READ_ONLY,
] as const;

export const TP_NOT_EDITABLE_STATUSES = [
  TREATMENT_PLAN_V3_STATUS.STARTED,
  TREATMENT_PLAN_V3_STATUS.EDITING,
  TREATMENT_PLAN_V3_STATUS.READ_ONLY,
] as const;

export const TP_DOWNLOADABLE_STATUSES = [
  TREATMENT_PLAN_V3_STATUS.COMPLETED,
  TREATMENT_PLAN_V3_STATUS.READ_ONLY,
] as const;

export const TP_REPORTABLE_STATUSES = [
  TREATMENT_PLAN_V3_STATUS.COMPLETED,
  TREATMENT_PLAN_V3_STATUS.READ_ONLY,
  TREATMENT_PLAN_V3_STATUS.EDITING,
] as const;

export const TP_OPTIONS_MENU_ITEM_IDS = {
  CREATE_FROM_INTAKE: 'createFromIntake',
  CREATE_BLANK: 'createBlank',
  CLONE: 'clone',
  SELECT_PLAN: 'selectPlan',
  EDIT: 'edit',
  DELETE: 'delete',
  VIEW_ACTIVATION: 'viewActivation',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  PROGRESS_REPORT: 'progressReport',
  DOWNLOAD: 'download',
  SEND_FOR_SIGNATURE: 'sendForSignature',
} as const;

export const TP_OPTIONS_SUBMENU_IDS = {
  BLANK_PLAN: 'blankPlan',
  CLONE_PLAN: 'clonePlan',
  SELECT_PLAN: 'selectPlan',
} as const;

export const TP_OPTIONS_MENU_ID = 'treatmentPlanV3OptionsMenu';
export const TP_OPTIONS_MENU_WIDTH = 290;
export const PROGRESS_REPORT_LOOKBACK_DAYS = 365;
export const PROGRESS_REPORT_DATE_FORMAT = 'YYYY-MM-DD';

export const PA_EXPIRES_WITHIN_DAYS = 180;
export const PA_EXPIRY_WARNING_DAYS = 60;
export const PA_EXPIRY_CRITICAL_DAYS = 30;

export const ALL_CLIENTS_ROLES: Roles[] = [Roles.Admin, Roles.ClientSuccessManager];
export const CLIENT_SWITCH_CONFIRM_ROLES: Roles[] = [Roles.Bcba, Roles.AssistantAssessor];
export const PLAN_CREATOR_ROLES: Roles[] = [Roles.Bcba, Roles.AssistantAssessor];
export const PLAN_EDITOR_ROLES: Roles[] = [Roles.Bcba];
export const PLAN_DELETE_ROLES: Roles[] = [Roles.Admin, Roles.Bcba];
export const PROGRESS_REPORT_ROLES: Roles[] = [Roles.Admin, Roles.Bcba, Roles.ClientSuccessManager];
export const DOWNLOAD_TP_ROLES: Roles[] = [
  Roles.Admin,
  Roles.AssistantAssessor,
  Roles.Bcba,
  Roles.Biller,
  Roles.InvoiceCoordinator,
  Roles.ClientSuccessManager,
  Roles.QaSpecialist,
];

export const PLAN_BAY_OPTIONS: ReadonlyArray<PlanBayOption> = [
  { label: 'Bay 2.5', bay: BAYS.BAY_2_5, testId: 'bay2_5TPCreate' },
  { label: 'Bay 2.6', bay: BAYS.BAY_2_6, testId: 'bay2_6TPCreate' },
  // The backend has no BAY 2.7 value, so this row sends BAY 2.6 like the legacy "Bay 2.6/7" item.
  { label: 'Bay 2.7', bay: BAYS.BAY_2_6, testId: 'bay2_7TPCreate' },
  { label: 'Bay 3.0', bay: BAYS.BAY_3, testId: 'bay3_0TPCreate' },
  { label: 'Bay 6.0', bay: BAYS.BAY_6, testId: 'bay6_0TPCreate' },
  { label: 'Bay 7.0', bay: BAYS.BAY_7, testId: 'bay7_0TPCreate' },
];
